import { makeStyles } from '@material-ui/core/styles';

export const getHoverStyle = (theme) => ({
  backgroundColor: theme.palette.table.row.hover,
  boxShadow: '0 0 0.2rem grey',
  cursor: 'pointer',
});

const useStyles = makeStyles((theme) => ({
  root: {
    '&$hover:hover': getHoverStyle(theme),
  },
  hover: {
    '&:hover': getHoverStyle(theme),
  },
}));

export default useStyles;
